import React, { Fragment, createRef, useState, useEffect } from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { Button, Tooltip, makeStyles } from '@material-ui/core'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { getFormSyncErrors, hasSubmitFailed } from 'redux-form'
import { showModal } from '../../../../redux/actions'
import InstructionModal from './InstructionModal'
import InfoIcon from '@material-ui/icons/Info'

var get = require('lodash.get')

const useTooltipStyles = makeStyles(theme => ({
	tooltip: {
		backgroundColor: '#e6f2ff',
		color: 'black', 
		boxShadow: '0 1px 1px #ccc', 
		maxWidth: '768px',
		width: 'auto'
	}
  }))

export default ({
	title,
	titleRequered,
	instructions,
	position,
	positionDisplay,
	children,
	canRemoveAnswer,
	onRemoveAnswer,
	formName,
	inputName,
	isDropdown,
	displayInstructionAsIcon,
	isBilateral = false
}) => {
	let ref = createRef()
	const intl = useIntl()
	const fieldError = formName ? useSelector(state => getFormSyncErrors(formName)(state)) : null
	const submitFailed = formName ? useSelector(state => hasSubmitFailed(formName)(state)) : false
	const errorMessage = inputName && submitFailed && fieldError && get(fieldError, inputName)
	const dispatch = useDispatch()
	const tooltipStyles = useTooltipStyles()

	const instructionClickHandler = () => {
		dispatch(showModal(InstructionModal,
			{
				title: title,
				text: instructions
			}
		))
	}

	return (
		<div style={{ display: 'table', width: '100%' }}>
			{title &&
				position && (

					<Grid
						data-testid="question-container"
						className={`questionWrapper${errorMessage ? " questionWrapper-error" : ""}${isDropdown ? " questionWrapperDropdown" : ""}`}
						container>
						<Grid item style={{ width: '100%' }}>
							<Grid container direction='row' style={{ width: '100%', justifyContent: 'space-between' }}>
								<Grid item>
									{
										!isBilateral
										&&
										<Fragment>
											<Grid container direction='row' spacing={1}>
												<Grid item>
													<Typography data-testid="question-container-title" className="question-container-title" variant='h2' style={{ fontSize: '22px', margin: '5px 0' }}>
														<span>{title}</span>
														<span className="Mui-error">{titleRequered}</span>
													</Typography>
												</Grid>
												{displayInstructionAsIcon
												&& instructions
												&& instructions.trim()
												&&
												<Grid item style={{ display: 'flex', alignItems: 'center'}}>

													<Tooltip 
														enterTouchDelay={0}
														disableTouchListener={true}
														title={
															<Typography color="inherit" style={{ fontSize: '12px' }}>
																<span dangerouslySetInnerHTML={{ __html: instructions }} />
															</Typography>
														}
														classes={{
															tooltip: tooltipStyles.tooltip
														}}
													>
														<InfoIcon style={{ fontSize: '20px', color: '#007aff', marginRight: '5px' }}  />
													</Tooltip>
													<Grid item>
													<Button
													data-testid="writable-question-instructions"
													style={{ display: 'flex', textAlign: 'left', width: 'auto' }}
													onClick={instructionClickHandler} >
														<Typography
															data-testid="writable-question-instructions-helper"
															variant='body2'
															style={{ opacity: '0.8', color: '#000', textDecoration: 'underline', fontSize: '14px' }}>
															{intl.formatMessage({ id: 'app.survey.questions.instructionIconHelperText' })}
														</Typography>
													</Button>
													</Grid>
												</Grid>}
											</Grid>
										</Fragment>
									}
								</Grid>

							</Grid>
						</Grid>

						{
							!isBilateral
							&& instructions
							&& !displayInstructionAsIcon
							&& <Grid item style={{ width: '100%' }}>
								<Grid container spacing={3}>
									<Grid item xs={12}>
										<Typography data-testid="question-container-instructions" variant='body1'>
											<span style={{ color: '#222' }}>
												<span dangerouslySetInnerHTML={{ __html: instructions }} />
											</span>
										</Typography>
									</Grid>
								</Grid>
							</Grid>
						}
						<Grid item style={{ width: '100%', marginTop: '16px' }}>
							{children && (
								<Grid container spacing={!isBilateral ? 3 : 0}>
									<Grid item xs={12} data-testid="question-container-children" className="question-container-children">
										{children}
									</Grid>
								</Grid>
							)}
						</Grid>

						{!!canRemoveAnswer && <Grid item className="button-remove-answer-wrapper">
							<Button
								data-testid="writable-question-container-remove-answer"
								className="button-remove-answer"
								onClick={onRemoveAnswer}
								variant='outlined'
								color='primary'
								type='button'
								size='small'>
								{intl.formatMessage({ id: 'app.cases.removeAnswer' }).toUpperCase()}
							</Button>
						</Grid>}
					</Grid>
				)}
		</div>
	)
}
